export const NUMERIC_ONLY_REGEX = /^[0-9]*$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PASSWORD_REGEX = {
  SPECIAL: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/,
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /[0-9]/,
} as const;

export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9][-a-zA-Z0-9]*\.)+[a-zA-Z]{2,}(\/[-a-zA-Z0-9%_.~#?&=]*)*$/;

export const URL_DETECTION_REGEX =
  /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gi;

export const ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const REPEATED_CHAR_REGEX = /^(.)\1{1,10}$/;

export const PHONE_INPUT_REGEX =
  /^[+]?[0-9\s\-()./]*(\s?(ext|extension|x)\s?\d+)?$/i;

export const ORGANIZATION_SLUG_REGEX = /^(?!.*--)[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?$/;
